import React, { useState } from "react";
import clsx from "clsx/lite";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import useClickOutside from "hooks/useClickOutside";

const CustomDropdown = ({
	Label, Preview, values = [], children, className, onSelect, buttonClassName
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const wrapperRef = useClickOutside(() => setIsOpen(false));

	const handleSelect = (value) => {
		onSelect && onSelect(value);
		setIsOpen(false);
	};

	return (
		<div className={clsx("relative mt-auto", className)} ref={wrapperRef}>
			{Label && <Label />}
			<button
				onClick={() => values?.length > 1 ? setIsOpen(!isOpen) : null}
				aria-expanded={isOpen}
				className={clsx("flex items-center w-full justify-between border px-2 sm:pl-4 sm:pr-2 py-2.5", buttonClassName)}
			>
				<div className="flex items-center w-full">
					{Preview && <Preview />}
				</div>
				{values?.length > 1 ? <span className="size-5"><Arrow className="size-5 rotate-90" /></span> : null}
			</button>
			{isOpen && (
				<div
					className={clsx(
						"absolute w-full bg-white border-x border-b z-10 overflow-y-auto max-h-40",
						values.length > 4 && "shadow-inner-bottom show-scrollbar"
					)}
				>
					{React.Children.map(children, child =>
						React.cloneElement(child, {
							onClick: child.props.value
								? () => handleSelect(child.props.value)
								: child.props.onClick
						})
					)}
				</div>
			)}
		</div>
	);
};

export default CustomDropdown;